// Author Lin
// Date 2021-10-09 10:46:58

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingResistanceBeforeIronModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingResistanceBeforeIron(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
